<template>
    <div>
      <homeNav></homeNav>
      <div class="content">
        <router-view></router-view>
      </div>
      <footerC></footerC>
    </div>
</template>
<script type="text/ecmascript-6">
  import homeNav from './modules/nav.vue'
  import footerC from './modules/bottom.vue'
    export default {
      name:'home',
      data() {
        return {
        };
      },
      components:{
        homeNav,
        footerC
      }
    }
</script>
<style>
  @import "../assets/less/nav.css";
</style>



// WEBPACK FOOTER //
// src/components/home.vue